export const PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.emergent.knightskingdoms.y2pjlw";
export const CONTACT_EMAIL = "m.woud93@gmail.com";
export const IMAGES = {
  heroCastle:
    "https://images.unsplash.com/photo-1514539079130-25950c84af65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbWVkaWV2YWwlMjBjYXN0bGUlMjBmb2d8ZW58MHx8fHwxNzkxMjcyNzgzfDA&ixlib=rb-4.1.0&q=85",
  knight:
    "https://images.unsplash.com/photo-1460194436988-671f763436b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxtZWRpZXZhbCUyMGtuaWdodCUyMGRhcmt8ZW58MHx8fHwxNzkxMjcyNzgzfDA&ixlib=rb-4.1.0&q=85",
  mountedKnight:
    "https://images.pexels.com/photos/29189099/pexels-photo-29189099.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
